// "Preview before publish" support.
//
// The admin can stash the current (unsaved) editor state in localStorage and
// open the public site with `?preview=1`. The site then renders that stashed
// content instead of what's live in Cloudflare. Nothing is written to the
// server, so previewing never affects real visitors — and because it's keyed by
// the same section names the editors already use, it lines up with fetchSection.

const PREFIX = "nusex_preview:";
const FLAG = "nusex_preview_active";

export interface PreviewSection {
  section: string;
  data: unknown;
}

export function writePreview(sections: PreviewSection[]): void {
  try {
    sections.forEach(({ section, data }) => {
      localStorage.setItem(PREFIX + section, JSON.stringify(data));
    });
    localStorage.setItem(FLAG, "1");
  } catch {
    // localStorage may be unavailable/full — preview is best-effort.
  }
}

export function isPreviewMode(): boolean {
  try {
    return (
      new URLSearchParams(window.location.search).get("preview") === "1" &&
      localStorage.getItem(FLAG) === "1"
    );
  } catch {
    return false;
  }
}

export function readPreview<T>(section: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + section);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}
